import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { RoleGuard } from '../../guards/role.guard';
import { CaseAssessmentComponent } from './case-assessment/case-assessment.component';
import { EmailThreadComponent } from './email-thread/email-thread.component';
import { EmailThreadGroupingsComponent } from './email-thread-groupings/email-thread-groupings.component';
import { Role } from '../../models/role.model';
import { PrerequisitesGuard } from '../../guards/prerequisites.guard';
import { SearchReportsComponent } from './search-report/search-reports/search-reports.component';
import { AutoRedactionComponent } from './auto-redaction/auto-redaction/auto-redaction.component';
import { CustodianComponent } from './custodians/custodian/custodian.component';
import { CaseNotesComponent } from './case-notes/case-notes.component';
import { FactsAndIssuesComponent } from './facts-and-issues/facts-and-issues.component';
import { FactEditComponent } from './facts-and-issues/fact-edit/fact-edit.component';
import { FactsComponent } from './facts-and-issues/facts/facts.component';
import { NearDupTextGroupingsComponent } from './near-dup-text-groupings/near-dup-text-groupings.component';
import { AppContainerComponent } from "../layout/app-container/app-container.component";
import { CaseAnalyticsComponent } from './case-analytics/case-analytics.component';

const analyticsRoute: Routes = [
	{ path: 'CaseAssessment', redirectTo: 'analytics/case-assessment', pathMatch: 'full' },
	{ path: 'case-assessment', redirectTo: 'analytics/case-assessment', pathMatch: 'full' },
	{ path: 'EmailThread/:id', redirectTo: 'analytics/email-thread/:id', pathMatch: 'full' },
	{ path: 'email-thread/:id', redirectTo: 'analytics/email-thread/:id', pathMatch: 'full' },
	{ path: 'EmailThreadGroupings', redirectTo: 'analytics/email-thread-groupings', pathMatch: 'full' },
	{ path: 'email-thread-groupings', redirectTo: 'analytics/email-thread-groupings', pathMatch: 'full' },
	{ path: 'SearchReport', redirectTo: 'analytics/search-report', pathMatch: 'full' },
	{ path: 'search-report', redirectTo: 'analytics/search-report', pathMatch: 'full' },
	{ path: 'SearchReport', redirectTo: 'analytics/search-report/:id', pathMatch: 'full' },
	{ path: 'search-report', redirectTo: 'analytics/search-report/:id', pathMatch: 'full' },
	{ path: 'near-dup-text-groupings', redirectTo: 'analytics/near-dup-text-groupings', pathMatch: 'full' },
	{
		path: 'analytics',
		component: AppContainerComponent,
		children: [
			{
				path: 'case-assessment',
				component: CaseAssessmentComponent,
				canActivate: [PrerequisitesGuard, RoleGuard],
				data: { roles: [Role.StandardFeatureSet] }
			},
			{
				path: 'case-analytics',
				component: CaseAnalyticsComponent,
				canActivate: [PrerequisitesGuard, RoleGuard],
				data: { roles: [Role.StandardFeatureSet] }
			},
			{
				path: 'case-notes',
				component: CaseNotesComponent,
				canActivate: [PrerequisitesGuard, RoleGuard],
				data: { roles: [Role.StandardFeatureSet, Role.Administrator] }
			},
			{
				path: 'email-thread/:id',
				component: EmailThreadComponent,
				canActivate: [PrerequisitesGuard, RoleGuard],
				data: { roles: [Role.StandardFeatureSet] }
			},
			{
				path: 'email-thread-groupings',
				component: EmailThreadGroupingsComponent,
				canActivate: [PrerequisitesGuard, RoleGuard],
				data: { roles: [Role.StandardFeatureSet] }
			},
			{
				path: 'search-report',
				component: SearchReportsComponent,
				canActivate: [PrerequisitesGuard, RoleGuard],
				data: { roles: [Role.StandardFeatureSet, Role.Administrator] }
			},
			{
				path: 'auto-redaction',
				component: AutoRedactionComponent,
				canActivate: [PrerequisitesGuard, RoleGuard],
				data: { roles: [Role.StandardFeatureSet, Role.Administrator] }
			},
			{
				path: 'custodians',
				component: CustodianComponent,
				canActivate: [PrerequisitesGuard, RoleGuard],
				data: { roles: [Role.StandardFeatureSet, Role.Administrator] }
			},
			{
				path: 'facts-and-issues',
				component: FactsAndIssuesComponent,
				canActivate: [PrerequisitesGuard, RoleGuard],
				data: { roles: [Role.StandardFeatureSet, Role.Administrator] },
				children: [
					{
						path: '',
						redirectTo: 'all',
						pathMatch: 'full'
					},
					{
						path: 'all',
						component: FactsComponent,
						canActivate: [PrerequisitesGuard, RoleGuard],
						data: { roles: [Role.StandardFeatureSet, Role.Administrator] }
					},
					{
						path: 'fact/:id',
						component: FactEditComponent,
						canActivate: [PrerequisitesGuard, RoleGuard],
						data: { roles: [Role.StandardFeatureSet, Role.Administrator] }
					},
				]
			},
			{
				path: 'near-dup-text-groupings',
				component: NearDupTextGroupingsComponent,
				canActivate: [PrerequisitesGuard, RoleGuard],
				data: { roles: [Role.StandardFeatureSet] }
			}
		]
	}
];

@NgModule({
	imports: [
		RouterModule.forChild(analyticsRoute)
	],
	exports: [
		RouterModule
	]
})
export class AnalyticsRoutingModule {
}
